import React from 'react';
import { FieldCheckBox, FieldDatepicker, FieldInput, FormCol, FormRow } from 'motion-components';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  currentItemPrice,
  formatDateSafe,
  formatPrice,
  priceCalculationMethodLabel,
} from '../../items/item-price';

/** Προβολή template. Τα πεδία μένουν κλειδωμένα μέχρι να ανοίξει η επεξεργασία. */
export const FormFields = ({ data }) => {
  const { t } = useTranslation();
  const canEdit = false;

  const lines = [...(data?.cntContributionTemplatesItems ?? [])].sort(
    (a, b) => (a.aa ?? 0) - (b.aa ?? 0),
  );

  return (
    <>
      <FormRow>
        <FieldInput disabled={!canEdit} as={FormCol} label={t('Ονομασία')} name="name" />
        <FieldDatepicker
          disabled={!canEdit}
          as={FormCol}
          label={t('Ισχύς από')}
          name="fromDate"
          showTimeSelect={false}
          dateFormat="d/M/yyyy"
        />
        <FieldDatepicker
          disabled={!canEdit}
          as={FormCol}
          label={t('Ισχύς έως')}
          name="tillDate"
          showTimeSelect={false}
          dateFormat="d/M/yyyy"
        />
        <FieldCheckBox
          disabled={!canEdit}
          as={FormCol}
          label={t('Ενεργή Εγγραφή')}
          name="isActive"
          onLabel={t('ΝΑΙ')}
          offLabel={t('ΟΧΙ')}
        />
      </FormRow>

      <h5 className="mt-4">{t('Είδη template')}</h5>
      <Table striped bordered hover size="sm" className="mt-2">
        <thead>
          <tr>
            <th>{t('Α/Α')}</th>
            <th>{t('Κωδικός')}</th>
            <th>{t('Ομάδα')}</th>
            <th>{t('Υποομάδα')}</th>
            <th>{t('Είδος')}</th>
            <th>{t('Υπολογισμός τιμής')}</th>
            <th className="text-end">{t('Τρέχουσα τιμή')}</th>
            <th>{t('Ισχύς από')}</th>
            <th className="text-center">{t('Ενεργό')}</th>
          </tr>
        </thead>
        <tbody>
          {lines.length === 0 && (
            <tr>
              <td colSpan={9} className="text-center text-muted">
                {t('Δεν υπάρχουν είδη σε αυτό το template')}
              </td>
            </tr>
          )}
          {lines.map((line) => {
            const price = currentItemPrice(line.cntItem?.itemPrices);
            return (
              <tr key={line.id}>
                <td>{line.aa}</td>
                <td>{line.cntItem?.code}</td>
                <td>{line.cntItem?.group?.name}</td>
                <td>{line.cntItem?.subgroup?.name}</td>
                <td>{line.cntItem?.name}</td>
                <td>{priceCalculationMethodLabel(line.cntItem?.priceCalculationMethod, t)}</td>
                <td className="text-end">{formatPrice(price?.price)}</td>
                <td>{formatDateSafe(price?.fromDate)}</td>
                <td className="text-center">{line.isActive === false ? t('ΟΧΙ') : t('ΝΑΙ')}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};
